import ApiClientFactory from '../services/ApiClientFactory';

let client;

if (undefined === client) {
    client = new ApiClientFactory();
}

export default client;
